import React from 'react';
import ReactDOM from 'react-dom/client';
import './assets/style/appDropdown.css';
import './assets/style/login.css';
import './assets/style/index.css';
import './assets/style/nav-bar.css';
import './assets/style/side-bar.css';
import './assets/style/right-side-modal.css';
import './assets/style/needs-attention.css';
import './assets/style/report-summary.css';
import './assets/style/analytics.css';
import './assets/style/product-summary.css';
import './assets/style/dashboard-cards.css';
import './assets/style/license-card.css';
import './assets/style/wh.css';
import './assets/style/colors.css';
import './assets/style/font-family.css';
import './assets/style/font-size.css';
import './assets/style/card.css';
import './assets/style/input.css';
import './assets/style/dropdown.css';
import './assets/style/cp-index.css';
import './assets/style/cp-top-status.css';
import './assets/style/cp-side-bar.css';
import './assets/style/receipt.css';
import './assets/style/pretty-json.css';
import './assets/style/table-classic.css';
import './assets/style/tree.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import App from './App';
import i18n from './i18n';
import { I18nextProvider } from 'react-i18next';
import i18next from 'i18next';
import { AuthProvider } from './context/AuthProvider';
import checkLicense from './services/licenseService';
import LicenseError from './pages/LicenseError';

const root = ReactDOM.createRoot(document.getElementById('root'));

(async () => {
  const result = await checkLicense();

  if (!result.valid) {
    // Needs the provider of its own: this renders instead of <App />, and the
    // screen is translated.
    root.render(
      <I18nextProvider i18n={i18next}>
        <LicenseError result={result}/>
      </I18nextProvider>
    );
    return;
  }

  root.render(
    <React.StrictMode>
      <AuthProvider>
        <I18nextProvider i18n={i18next}>
          <App />
        </I18nextProvider>
      </AuthProvider>
    </React.StrictMode>
  );
})();